import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';

import moment from 'moment';

const contents = {
    state: {
        studiesAutocomplete: null
    },
    getters: {
        getStudiesAutocomplete: state => state.studiesAutocomplete,
    },
    actions: {
        requestEntries({ commit }, data) {

            return new Promise((resolve) => {
                axios.post('/api/entry', data).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },

        requestEntrie({ commit }, slug) {

            return new Promise((resolve) => {
                axios.get('/api/entry/' + slug).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },

        requestEntrevistas({ commit }, data) {

            return new Promise((resolve) => {
                axios.post('/api/interview', data).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },

        requestEntrevista({ commit }, slug) {

            return new Promise((resolve) => {
                axios.get('/api/interview/' + slug).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },


        requestEmprendedores({ commit }) {

            let data = {
                "order": [
                    {
                        name: 'created_at',
                        direction: 'desc'
                    }
                ]
            }

            return new Promise((resolve) => {
                axios.post('/api/business_creator', data).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },
        requestStudyAutocomplete({ commit }, data) {
            return new Promise((resolve) => {
                axios.get('/api/masterdata/study/autocomplete?term=', data).then(response => {
                    resolve(response.data);
                    commit('setStudyAutocomplete', response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },
        getAutocomplete({ commit }, data) {

            let urls = {
                'study': '/api/masterdata/study/autocomplete?term=',
                'study_ufv': '/api/masterdata/study/autocomplete/ufv?term=',
                'study_noufv': '/api/masterdata/study/autocomplete/noufv?term=',
                'university': '/api/masterdata/university/autocomplete?term=',
                'university_ufv': '/api/masterdata/university/autocomplete/ufv?term=',
                'university_noufv': '/api/masterdata/university/autocomplete/noufv?term=',
                'traicing': '/api/masterdata/tracing_type/autocomplete?term=',
                'sector': '/api/masterdata/sector/autocomplete?term=',
                'langs': '/api/masterdata/langs/autocomplete?term=',
                'personal_type': '/api/masterdata/personal_type/autocomplete?term=',
                'area': '/api/masterdata/area/autocomplete?term=',
                'alumni': '/api/alumni/autocomplete?term=',
                'user': '/api/user/autocomplete?term=',
                'ufv': '/api/masterdata/university/autocomplete/ufv?term='
            }

            return new Promise((resolve) => {
                axios.get(urls[data.type] + data.term).then(response => {


                    resolve(response.data);
                })
                    .catch(error => {
                        commit('setCustomAlert', error.response.data.messages);
                        resolve(false);
                    });
            });
        },



        requestEventos({ commit }) {

            let data = {
                filters: [
                    {
                        name: 'category.parents',
                        search: 0,
                    },
                    {
                        name: 'date',
                        search: `${moment().format('YYYY/MM/DD')}T23:59%datetime-local%2080/11/31T23:59`
                    },
                ],
                "order": [
                    {
                        name: 'date',
                        direction: 'asc'
                    }
                ],
                length: 4
            }

            return new Promise((resolve) => {
                axios.post('/api/event', data).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },


        requestAllEventos({ commit }, data) {


            return new Promise((resolve) => {
                axios.post('/api/event', data).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },



        requestEventosPasados({ commit }) {



            let data = {
                filters: {
                    date: {
                        name: 'date',
                        search: `2000/08/05T00:00%datetime-local%${moment().format('YYYY/MM/DD')}T23:59`
                    },
                },
                length: 4
            }

            return new Promise((resolve) => {
                axios.post('/api/event', data).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },

        requestEvento({ commit }, slug) {

            return new Promise((resolve) => {
                axios.get('/api/event/' + slug).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },

        requestInscripcion({ commit }, { id, type = 0 }) {
            return new Promise((resolve) => {
                axios.post('/api/event/register/' + id + '?type=' + type).then(response => {
                    if (response.data.status) {
                        resolve(true);
                        commit('setAlert', 1011);
                    } else {
                        resolve(false);
                        if (response.data.error == 0) {
                            commit('setAlert', 1007);
                        }
                    }
                    resolve(response.data.status);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },

        requestInscripcionAbierta({ commit }, data) {
            return new Promise((resolve) => {
                axios.post('api/event/register/open/' + data.event_id, data).then(response => {
                    if (response.data.status) {
                        resolve(true);
                    } else {
                        resolve(false);
                        if (response.data.error == 0) {
                            commit('setAlert', 1007);
                        }
                    }
                    resolve(response.data.status);
                }).catch(error => {
                    if (error.response.status == '403') {
                        resolve(error.response.status);
                    } else {
                        commit('setCustomAlert', error.response.data.messages);
                    }
                    resolve(false);
                });
            });
        },

        requestCancelInscripcion({ commit }, id) {

            return new Promise((resolve) => {
                axios.post('/api/event/cancel/' + id).then(response => {
                    if (response.data.status) {
                        resolve(true);
                        commit('setAlert', 1006);
                    } else {
                        resolve(false);

                    }
                    resolve(response.data.status);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        },


        sendContact({ commit }, data) {
            return new Promise((resolve) => {
                axios.post('/api/contacto', data).then(response => {
                    if (response.data.status) {
                        resolve(true);
                        commit('setAlert', 1009);
                    } else {
                        resolve(false);

                    }
                    resolve(response.data.status);
                }).catch(error => {
                    commit('setCustomAlert', error.response.data.messages);
                    resolve(false);
                });
            });
        }




    },
    mutations: {
        setStudyAutocomplete(state, data) {
            state.studiesAutocomplete = data;
        }
    }
}

export default contents;
